import dataManager from './modules/dataManager';

import infoLive from './controllers/infoLive';
import voting from './controllers/voting';
import hemicycle from './controllers/hemicycle';
import pactometer from './controllers/pactometer';
import partyVoteList from './controllers/partyVoteList';
import mostVotedParty from './controllers/mostVotedParty';
import percentageOfVotes from './controllers/percentageOfVotes';

import search from './components/search';
import showMore from './components/showMore';
import tabs from './components/tabs';
import anchors from './components/anchors';

window.dataManager = dataManager;
dataManager.init();

anchors();
search();
showMore();
tabs();

infoLive();
voting();
hemicycle();
pactometer();
partyVoteList();
mostVotedParty();
percentageOfVotes();
